import { Box, Stack, Typography } from "~/common/mui";
import { useTranslation } from "react-i18next";
import type { PredecessorProduct } from "~/domains/product/types/PackagingOption";

interface PredecessorProductItemProps {
  product: PredecessorProduct;
}

export const PredecessorProductItem = ({ product }: PredecessorProductItemProps) => {
  const { t } = useTranslation();
  return (
    <Stack key={product.sapMaterialNo} direction="row" gap={2} alignItems="center">
      {product.imageUrl && (
        <Box
          component="img"
          src={product.imageUrl}
          alt={product.designation}
          sx={{ width: 64, height: 64, objectFit: "contain" }}
        />
      )}
      <Stack>
        <Typography variant="titleMedium" fontWeight="bold">
          {product.designation}
        </Typography>
        <Stack direction={"row"} gap={1}>
          <Typography color="text.label">{t("product.schaefflerId")}</Typography>
          <Typography color="text.secondary">{product.sapMaterialNo}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
